import secondaryMarketReducer from './reducer.market';
import * as companySelectors from './selectors.market';
import ISecondaryMarketReducer from '../interfaces/ISecondaryMarketReducer';

type TSecondaryMarketRootReducer = {
  readonly secondaryMarketReducer: ISecondaryMarketReducer;
};

export { TSecondaryMarketRootReducer, companySelectors };

export default secondaryMarketReducer;
